import FormController from './components/form_controller';

export default class StorefrontLocationsController extends FormController {
  dropdownIds = ['per_page'];

  static targets = [
    'form',
  ];

  // TODO: Consolidate this with storefront_groups_controller
  // Call on checkbox toggle
  updateHeader() {
    // Get count of locations checked
    const locationCount = document.getElementById('amount-checked');

    // Get all location checkboxes
    const allLocations =
      document.querySelectorAll('.locations-table .tabulator-row .input-checkbox input[type=checkbox]');

    // Get all checked locations
    const locationsChecked = Array.from(allLocations).filter((checkbox) => {
      return checkbox.checked;
    });

    // Update Checked Count
    locationCount.textContent = locationsChecked.length;

    // Update buttons
    document.querySelectorAll('.button-horz-group .button-secondary').forEach((button) => {
      button.disabled = !locationsChecked.length;
    });
  }

  checkAll(e) {
    const isChecked = e.target.checked;

    document.querySelectorAll(
      '.locations-table .tabulator-row .input-checkbox input[type=checkbox]').forEach((toggle) => {
      toggle.checked = isChecked;
    });

    this.updateHeader();
  }

  // Pagination dropdown
  dropdownUpdate(e) {
    const dropdown = e.detail.dropdown;

    if (dropdown.id === 'per_page') {
      const perPageValue = dropdown.inputTarget.value;
      this.formTarget.querySelector('input[name="per_page"]').value = perPageValue;
    }
  }
}
